'use client';
import React, { useEffect, useState } from 'react';

import NextImage, { ImageProps as NextImageProps } from 'next/image';

import { FALLBACK_IMAGE_URL } from '@constants/constants';

export interface ImageProps extends NextImageProps {
  fallbackSrc?: string;
}

const Image = ({
  src = FALLBACK_IMAGE_URL,
  fallbackSrc = FALLBACK_IMAGE_URL,
  ...rest
}: ImageProps) => {
  const [imgSrc, setImgSrc] = useState(src);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setImgSrc(src || fallbackSrc);
    setLoading(true);
  }, [src, fallbackSrc]);

  const handleOnError = () => {
    setImgSrc(fallbackSrc);
    setLoading(false);
  };

  const handleOnLoad = () => {
    setLoading(false);
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      {loading && (
        <div
          className='image-skeleton'
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background:
              'linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%)',
            backgroundSize: '200% 100%',
            animation: 'skeleton-loading 1.2s ease-in-out infinite',
            borderRadius: '8px',
            zIndex: 2,
          }}
        />
      )}
      <style>{`
        @keyframes skeleton-loading {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
      <NextImage
        src={imgSrc}
        onError={handleOnError}
        onLoad={handleOnLoad}
        {...rest}
      />
    </div>
  );
};

export default Image;
